import request from '@/utils/request'
import qs from 'qs'

// VIP基本信息列表
export function getVIPInfoList(data: any) {
  return request({
    url: '/transact/vip_info',
    method: 'get',
    params: data
  })
}

// 从黑名单移除设备
export function switchBlackList(data: any) {
  return request({
    url: '/developerAccount/sealAccountUdidSwitch',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改绑定
export const changeUdid = (data: { udid: String; id: number; newUdid: String }) =>
  request({
    url: `/transact/vip_change_udid`,
    method: 'post',
    data: qs.stringify(data)
  })

// VIP订单列表
export function getVIPOrderList(data: any) {
  return request({
    url: '/transact/vip_order',
    method: 'get',
    params: data
  })
}

// 支付渠道映射列表
export function getPayTypeMap() {
  return request({
    url: '/trade/payTypeMap',
    method: 'get'
  })
}

// 支付状态映射列表
export function getPayStatusMap() {
  return request({
    url: '/trade/payStatusMap',
    method: 'get'
  })
}
// 支付物品分类映射
export function getGoodsTypeMap() {
  return request({
    url: '/trade/goodsTypeMap',
    method: 'get'
  })
}

// 添加VIP
export const addVIP = (data: { udid: String; days: number; isPermanent: Boolean }) =>
  request({
    url: `/transact/vip_info`,
    method: 'post',
    data: qs.stringify(data)
  })

// 兔币管理列表
export function getTubiList(data: any) {
  return request({
    url: '/user/tubi',
    method: 'get',
    params: data
  })
}

// 兔币订单列表查询
export function getTubiOrderList(data: any) {
  return request({
    url: '/transact/tubi_order',
    method: 'get',
    params: data
  })
}

// VIP价格列表
export function getVipPriceList(data: any) {
  return request({
    url: '/transact/vip_amount_list',
    method: 'get',
    params: data
  })
}

// 保存VIP价格
export const saveVipPrice = (data: any) =>
  request({
    url: '/transact/save_vip_amount',
    method: 'post',
    data: qs.stringify(data)
  })

// 上架
export const VipOn = (data: { ids: String }) =>
  request({
    url: '/transact/vip_amount_online',
    method: 'post',
    data: qs.stringify(data)
  })

// 下架
export const VipOff = (data: { ids: String }) =>
  request({
    url: '/transact/vip_amount_offline',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除
export const deletePrice = (data: { ids: String }) =>
  request({
    url: '/transact/delete_vip_amount',
    method: 'post',
    data: qs.stringify(data)
  })

// VIP优惠活动列表
export function getActivityList(data: any) {
  return request({
    url: '/transact/discount_activity_list',
    method: 'get',
    params: data
  })
}

// 保存VIP优惠活动（新增或者修改）
export const saveVipActivity = (data: any) =>
  request({
    url: '/transact/save_discount_activity',
    method: 'post',
    data: qs.stringify(data)
  })

// 上架
export const activityOn = (data: { ids: String }) =>
  request({
    url: '/transact/discount_activity_online',
    method: 'post',
    data: qs.stringify(data)
  })

// 下架
export const activityOff = (data: { ids: String }) =>
  request({
    url: '/transact/discount_activity_offline',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除
export const deleteActivity = (data: { ids: String }) =>
  request({
    url: '/transact/delete_discount_activity',
    method: 'post',
    data: qs.stringify(data)
  })

// VIP设备重签次数列表
export function getVipResignList(params: any) {
  return request({
    url: '/transact/udid_resign_list',
    method: 'get',
    params
  })
}

// VIP设备重签记录列表
export function getVipResignRecordList(params: any) {
  return request({
    url: '/transact/vip_change_log_list',
    method: 'get',
    params
  })
}

// 修改VIP设备已重签次数
export const modifyResignCount = (data: any) =>
  request({
    url: '/transact/change_udid_resign_count',
    method: 'post',
    data: qs.stringify(data)
  })

// 添加VIP设备重签次数记录
export const addVipResignRecord = (data: any) =>
  request({
    url: '/transact/add_udid_resign_record',
    method: 'post',
    data: qs.stringify(data)
  })

// vip套餐重签次数下拉列表
export function getVipResignOptionList() {
  return request({
    url: '/transact/vip_resign_count_list',
    method: 'get'
  })
}
